import axios from "axios";
import { useEffect, useState } from "react";
import { Button, Container, Row, Table } from "react-bootstrap";
import { root_url } from "../setting";
class Runner {
  constructor(
    runnerSeq,
    ticketSeq,
    souvenir = null,
    choiceOption = null,
    runnerName = null,
    birthday = null,
    gender = null,
    cellphone = null,
    ticketName = null
  ) {
    this.runnerSeq = runnerSeq;
    this.ticketSeq = ticketSeq;
    this.souvenir = souvenir;
    this.choiceOption = choiceOption;
    this.runnerName = runnerName;
    this.birthday = birthday;
    this.gender = gender;
    this.cellphone = cellphone;
    this.ticketName = ticketName;
    this.backNo = null;
    this.chipNo = null;
  }
}

const RunnersParticipantForm = ({
  info,
  setRunnerList,
  runnerList,
  joiner, //from payment
  isOnPay = false,
  isEditPossible = true, //from payment
  setFlag,
}) => {
  const { ticketArray, ticketInfo } = info;
  const [onEditRunner, setOnEditRunner] = useState(!isOnPay); //runner 수정 가능한 시점인지
  const [canAddRunner, setCanAddRunner] = useState(!isOnPay); //runner 추가 가능 여부 -> payment에서는 불가능
  const [onUpdate, setOnUpdate] = useState(false); //현재 수정중인지 -> 중복확인 / 저장 버튼 결정
  const [needToCheck, setNeedToCheck] = useState(false); //수정모드에서 이름, 생년월일, 전화번호 바뀐 경우에 서버에서 확인해야함
  const [runnerName, setRunnerName] = useState("");
  const [runnerBirthday, setRunnerBirthday] = useState("");
  const [isParticipantMan, setIsParticipantMan] = useState(true);
  const [participantPhoneNum, setParticipantPhoneNum] = useState("");
  const [participantCourse, setParticipantCourse] = useState(0); //ticketSeq -1과 일치하며, ticketArray가 아닌 ticketInfo의 인덱스와 일치한다!!
  const [participantGift, setParticipantGift] = useState("");
  const [participantGiftOption, setParticipantGiftOption] = useState("110");
  const [today, setToday] = useState(new Date());
  const [firstDisabled, setFirstDisabled] = useState(false);
  const [souvenirList, setSouvenirList] = useState([]);
  const [souvenirOptionList, setSouvenirOptionList] = useState([]);
  //for update
  const [onUpdateRunnerInd, setOnUpdateRunnerInd] = useState();
  //for delete
  const [checkRunnerInd, setCheckRunnerInd] = useState([]);
  useEffect(() => {
    // console.log(ticketInfo[participantCourse]);
    console.log(ticketInfo);
    setSouvenirList([ticketInfo[participantCourse].souvenir]); //payment에서 수정눌렀을때 오류
    setParticipantGift([ticketInfo[participantCourse].souvenir][0]);
    if (ticketInfo[participantCourse].choiceOption) {
      //기념품이 존재하는 경우, giftList를 가져오도록 한다.
      const new_gift_list =
        ticketInfo[participantCourse].choiceOption === undefined
          ? null
          : ticketInfo[participantCourse].choiceOption.split(",");
      setSouvenirOptionList(new_gift_list);
      // setParticipantGiftOption(new_gift_list[0]);
    } else {
      setSouvenirOptionList(null);
    }
  }, [participantCourse, ticketInfo]);

  const updateRunnerInfo = () => {
    console.log(updateRunnerInfo);
    console.log(onUpdateRunnerInd);
    setOnEditRunner(false);
    let runnerVO;
    if ((runnerVO = checkRunnerInfo(false)) !== -1) {
      //정상 입력된 경우 서버에 업데이트 해서 반영해야함.
      console.log(runnerVO);
      axios({
        method: "put",
        url: `${root_url}/api/application/update/${joiner.joinSeq}`,
        data: runnerVO,
        headers: { "Content-Type": "application/json" },
      })
        .then((res) => {
          console.log(`${root_url}/api/application/update/${joiner.joinSeq}`);
          console.log(res);
        })
        .catch((e) => {
          if (e.response === undefined) {
            alert(
              "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
            );
          } else {
            alert(e.response.data.errorMessage);
          }
          return -1;
        });
    }
  };
  const checkRunnerInfo = (isAdd) => {
    // 이름, 생년월일, 성별, 전화번호, 종목, 기념품, 기념품 옵션 체크하고 유효하다면 runnerList에 추가
    // checkRunnerInd에도 하나 추가
    // 이름, 생년월일, 전화번호 중 하나라도 바뀌었을 경우에만 서버에서 확인하면 된다
    let duplicateRes = false;
    // 이름, 생년월일, 전화번호 유효한지 체크
    if (
      runnerName === "" ||
      runnerBirthday === "" ||
      participantPhoneNum === ""
    ) {
      alert("모든 정보를 입력해주세요");
      return -1;
    }

    let errorField = "";
    if (!runnerName.match(/^[A-Z|a-z|가-힣]{2,50}$/g)) {
      errorField += "이름은 공백없이(2글자 이상) 입력해주세요.\n";
    }

    if (!participantPhoneNum.match(/^01[016789]\d{3,4}\d{4}$/)) {
      errorField +=
        "전화번호는 4자 이상, 전화번호는 11자 이하의 숫자만 입력해주세요.\n";
    }
    if (!runnerBirthday.match(/^[0-9]{8,8}/g) || runnerBirthday.length !== 8) {
      errorField += "생년월일은 숫자 8자리로 입력해주세요.";
    }
    if (errorField !== "") {
      alert(errorField);
      return -1;
    }
    const fetchData = async () => {
      try {
        const { data } = await axios.get(
          `${root_url}/api/isDuplicate?name=${runnerName}&cellphone=${participantPhoneNum}&&birthday=${runnerBirthday}`
        );
        console.log(data);
        duplicateRes = data;
        if (!duplicateRes) {
          const runnerInfo = new Runner(
            runnerList[onUpdateRunnerInd]?.runnerSeq,
            ticketInfo[participantCourse].ticketSeq,
            participantGift,
            participantGiftOption,
            runnerName,
            runnerBirthday,
            isParticipantMan ? "M" : "F",
            participantPhoneNum,
            ticketInfo[participantCourse].ticketName
          );
          console.log("=======================", runnerInfo);
          console.log("participant gift : " + participantGift);
          console.log("participant option : " + participantGiftOption);
          if (isAdd) {
            setRunnerList([...runnerList, runnerInfo]);
            setFlag(false);
            setCheckRunnerInd([...checkRunnerInd, false]);
          } else {
            // 수정하는 경우,
            const runners = [...runnerList];
            runners[onUpdateRunnerInd] = runnerInfo;
            setRunnerList(runners);
            setFlag(false);
            console.log("=======================", runnerInfo);
            console.log("runners update!");
            console.log(runnerList);
            setCheckRunnerInd((check_list) => check_list.fill(false));
            setOnUpdate(false);
          }
          setRunnerName("");
          setRunnerBirthday("");
          setParticipantPhoneNum("");
          // return runnerInfo;
        } else {
          alert("해당 참가자는 이미 신청되어있습니다");
        }
      } catch (e) {
        console.log(e);
        alert(
          "시스템 서비스가 원할하지 않습니다. 관리자에게 문의하세요. (code - A0001)"
        );
      }
    };

    if (isAdd) {
      //추가하는 경우
      // 이미 있는 runner 정보인지 확인 -> 서버에도 확인해야함!
      const isRunner = runnerList.filter(
        (runner) =>
          runner.runnerName === runnerName &&
          runner.cellphone === participantPhoneNum &&
          runner.birthday === runnerBirthday
      );
      console.log(`isRunner ? ${isRunner}`);
      if (isRunner?.length >= 1) {
        alert("해당 참가자가 이미 참가자 목록에 존재합니다.");
        return -1;
      }
      fetchData(); //서버에도 확인
    } else {
      //수정 -> 저장하는 경우
      console.log(runnerName === runnerList[onUpdateRunnerInd].runnerName);
      if (
        runnerName === runnerList[onUpdateRunnerInd].runnerName &&
        participantPhoneNum === runnerList[onUpdateRunnerInd].cellphone &&
        runnerBirthday === runnerList[onUpdateRunnerInd].birthday
      ) {
        // key 값의 변경 사항 없는 경우, 서버에 확인할 필요 없음
        //runnerList 수정해서 반영
        const runnerInfo = new Runner(
          runnerList[onUpdateRunnerInd]?.runnerSeq,
          ticketInfo[participantCourse].ticketSeq,
          participantGift,
          participantGiftOption,
          runnerName,
          runnerBirthday,
          isParticipantMan ? "M" : "F",
          participantPhoneNum,
          ticketInfo[participantCourse].ticketName
        );
        console.log(runnerInfo);
        const runners = [...runnerList];

        console.log(`runners before mod : ${runners}`);
        console.log(runners);
        runners[onUpdateRunnerInd] = runnerInfo;
        console.log("on update runner index : " + onUpdateRunnerInd);
        setRunnerList(runners);
        setFlag(false);
        console.log(`runners after mod : ${runners}`);
        console.log(runners);
        setRunnerName("");
        setRunnerBirthday("");
        setParticipantPhoneNum("");
        setOnUpdate(false);
        return runnerInfo;
      } else {
        //현재 참가자 명단에 있는지부터 파악하고
        const isRunner = runnerList.filter(
          (runner) =>
            runner.runnerName === runnerName &&
            runner.cellphone === participantPhoneNum &&
            runner.birthday === runnerBirthday
        );
        console.log(`isRunner ? ${isRunner}`);
        if (isRunner?.length >= 1) {
          alert("해당 참가자가 이미 참가자 목록에 존재합니다.");
          return -1;
        }
        //서버에 확인해야함
        fetchData();
        setOnUpdate(false);
        const runnerInfo = new Runner(
          runnerList[onUpdateRunnerInd]?.runnerSeq,
          ticketInfo[participantCourse].ticketSeq,
          participantGift,
          participantGiftOption,
          runnerName,
          runnerBirthday,
          isParticipantMan ? "M" : "F",
          participantPhoneNum
        );
        return runnerInfo;
      }
    }

    //runnerInd와 달라진게 있는지 확인 달라진게 없다면 여기서 끝
    // 그게 아니라면 서버에 정보 확인
  };
  const onDeleteRunner = () => {
    console.log(checkRunnerInd);
    setFlag(false);
    setRunnerList((runnerList) =>
      runnerList.filter((runner, k) => !checkRunnerInd[k] && runner)
    );
    setCheckRunnerInd(
      (check_list) => check_list.filter((runner, k) => !runner && true) //check 안된 애들만 남기기
    );
  };
  const onUpdateRunner = (name, cellphone, birthday) => {
    console.log(`onUpdateRunner : ${name}, ${cellphone}, ${birthday}`);
    //payment 단계에서 참가자 정보를 수정할 때 호출
    //수정 버튼을 누르면 editRunner가 활성화 되며, 해당하는 runner 정보가 form에 들어가서 수정을 가능하게 한다
    //만약, 수정 완료를 하면 해당 참가자 정보에 반영이 되도록 한다
    setOnUpdate(true);
    setOnEditRunner(true);
    //1. 해당 name, cellphone인 참가자를 찾는다
    const runnerInd = runnerList.findIndex(
      (runner) =>
        runner.runnerName === name &&
        runner.cellphone === cellphone &&
        runner.birthday === birthday
    );
    setOnUpdateRunnerInd(runnerInd);
    const runnerWillUpd = runnerList[runnerInd];
    console.log(runnerWillUpd);
    //2. 해당 runner의 정보를 form에 넣어준다
    setRunnerName(runnerWillUpd.runnerName);
    setRunnerBirthday(runnerWillUpd.birthday);
    setIsParticipantMan(runnerWillUpd.gender === "M" ? true : false);
    setParticipantPhoneNum(runnerWillUpd.cellphone);
    setParticipantCourse(runnerWillUpd.ticketSeq - 1); //신청 시점에는 있었는데, 수정시점에는 해당 종목이 품절인 경우는 어떻게 되는지 확인..!
    setParticipantGift(runnerWillUpd.souvenir);
    setParticipantGiftOption(runnerWillUpd.choiceOption);
  };
  return (
    <Container className={`${isOnPay ? "" : "row m-0"} m-0`}>
      {(onEditRunner || (!isOnPay && onUpdate)) && (
        <>
          <Row className="text-start text-custom-color mb-5">
            {isOnPay ? <h3>참가자 정보 수정</h3> : <h3>참가자 신청</h3>}
          </Row>
          <div style={{ overflowX: "scroll", margin: 0 }}>
            <Table style={{ minWidth: "900px" }}>
              <thead>
                <tr>
                  <th width={"12%"}>이름</th>
                  <th width={"12%"}>생년월일</th>
                  <th width={"10%"}>성별</th>
                  <th width={"14%"}>전화번호</th>
                  <th width={"18%"}>종목</th>
                  <th>기념품</th>
                  <th>기념품 옵션</th>
                  {onEditRunner && <th width={"10%"}></th>}
                </tr>
              </thead>
              <tbody>
                {onEditRunner && (
                  <tr>
                    <td>
                      {/* 참가자 이름 : runnerName */}
                      <input
                        type="text"
                        className="form-in-class"
                        placeholder="홍길동"
                        value={runnerName}
                        onChange={(e) => {
                          setRunnerName(e.target.value);
                        }}
                      />
                    </td>
                    <td>
                      {/* 생년월일 :  runnerBirthday */}
                      <input
                        type="number"
                        className="form-in-class"
                        placeholder="19990320"
                        value={runnerBirthday}
                        onChange={(e) => {
                          setRunnerBirthday(e.target.value);
                        }}
                      />
                    </td>
                    <td>
                      {/* 성별 : isParticipantMan */}
                      <select
                        value={isParticipantMan}
                        onChange={(e) => {
                          console.log(e.target.value);
                          setIsParticipantMan(
                            e.target.value === "true" ? true : false
                          );
                        }}
                        className="custom-select"
                      >
                        <option value="true">남</option>
                        <option value="false">여</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="number"
                        className="form-in-class"
                        placeholder="01012345678"
                        value={participantPhoneNum}
                        onChange={(e) => {
                          setParticipantPhoneNum(e.target.value);
                        }}
                      />
                    </td>
                    <td>
                      {/* 신청 종목 : participantCourse */}
                      {/* 신청가능한 날인지, 품절되진 않았는지 */}
                      <select
                        value={participantCourse}
                        onChange={(e) => {
                          console.log("participantCourse : " + e.target.value);
                          setParticipantCourse(e.target.value);
                          setParticipantGift("0");
                        }}
                        className="custom-select"
                      >
                        {/* ticket이 일부 품절일 경우는 어떻게 되는지 꼭 확인하도록 하자! */}
                        {/* 시간이 null인 경우에 어떻게 처리해야 하는지!! */}
                        {ticketArray.map((ticket, key) => {
                          const inDuration =
                            new Date(ticket.saleOpenTime).getTime() <=
                              today.getTime() &&
                            today.getTime() <=
                              (ticket.saleCloseTime == null
                                ? new Date().getTime()
                                : new Date(ticket.saleCloseTime).getTime());
                          return (
                            <option
                              value={ticket.ticketSeq - 1}
                              key={ticket.ticketSeq}
                              disabled={
                                ticket.acceptable <= ticket.total || !inDuration
                              }
                            >
                              {/* {ticket.ticketName}|{ticket.ticketSeq - 1} */}
                              {ticket.ticketName}
                            </option>
                          );
                        })}
                      </select>
                    </td>
                    <td>
                      {/* 기념품 : participantGift*/}
                      <select
                        value={participantGift}
                        onChange={(e) => setParticipantGift(e.target.value)}
                      >
                        {souvenirList.map((souv, key) => (
                          <option key={souv}>{souv}</option>
                        ))}
                      </select>
                    </td>
                    <td>
                      {/* 기념품 옵션 : participantGiftOption */}
                      <select
                        value={participantGiftOption}
                        onChange={(e) =>
                          setParticipantGiftOption(e.target.value)
                        }
                      >
                        {souvenirOptionList.map((souv, key) => (
                          <option key={souv}>{souv}</option>
                        ))}
                      </select>
                    </td>
                    <td>
                      {onUpdate ? (
                        isOnPay ? (
                          // 조회 및 수정 or 결제 단계에서 수정하는 경우
                          <Button onClick={() => updateRunnerInfo()}>
                            저장
                          </Button>
                        ) : (
                          <Button onClick={() => checkRunnerInfo(false)}>
                            저장
                          </Button>
                        )
                      ) : (
                        !isOnPay && (
                          <Button
                            style={{ fontSize: "0.7rem" }}
                            onClick={() => checkRunnerInfo(true)}
                          >
                            중복 확인 & 추가
                          </Button>
                        )
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </>
      )}
      <Row className="text-start text-custom-color mb-5 mt-5">
        <h3>참가자 목록</h3>
      </Row>
      <div style={{ overflowX: "scroll", margin: 0 }}>
        <Table style={{ minWidth: "900px" }}>
          <thead>
            <tr>
              {canAddRunner && (
                <th>
                  <Button onClick={onDeleteRunner}>삭제</Button>
                </th>
              )}
              <th width={"12%"}>이름</th>
              <th width={"12%"}>생년월일</th>
              <th width={"10%"}>성별</th>
              <th width={"14%"}>전화번호</th>
              <th width={"18%"}>종목</th>
              <th>기념품</th>
              <th>기념품 옵션</th>
              {onEditRunner && <th></th>}
            </tr>
          </thead>
          <tbody>
            {runnerList?.map((runner, key) => (
              <tr key={key}>
                {canAddRunner && (
                  <td>
                    <input
                      type="checkbox"
                      checked={checkRunnerInd[key] ? true : false}
                      value={checkRunnerInd[key] ? true : false}
                      onChange={() => {
                        console.log("checked :" + checkRunnerInd[key]);
                        const new_list = checkRunnerInd;
                        for (let i in checkRunnerInd) {
                          if (i == key) new_list[i] = !new_list[i];
                        }
                        // new_list[key] = e.target.checked;
                        console.log(new_list);
                        setCheckRunnerInd([...new_list]);
                      }}
                    />
                  </td>
                )}
                <td>{runner.runnerName}</td>
                <td>{runner.birthday}</td>
                <td>{runner.gender === "M" ? "남" : "여"}</td>
                <td>{runner.cellphone}</td>
                <td>{ticketInfo[runner.ticketSeq - 1].ticketName}</td>
                <td>{runner.souvenir}</td>
                <td>{runner.choiceOption}</td>
                <td>
                  <Button
                    onClick={() => {
                      if (isEditPossible) {
                        onUpdateRunner(
                          runner.runnerName,
                          runner.cellphone,
                          runner.birthday
                        );
                      } else {
                        alert("수정이 필요한 경우 관리자에게 문의해주세요.");
                      }
                    }}
                  >
                    수정
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Container>
  );
};
export default RunnersParticipantForm;
